<template>
  <div class="grid grid-cols-2 gap-6">
    <div class="grid max-h-[38rem] pl-1 pr-6">
      <div>
        <div class="h-4 w-96 animate-pulse rounded-xl bg-neutral-99" />
        <div class="mt-4 h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
      </div>

      <hr class="my-0 border-neutral-95" />

      <div class="grid grid-cols-2 gap-4">
        <div>
          <div class="h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
          <div class="mt-4 h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
        </div>
        <div>
          <div class="h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
          <div class="mt-4 h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div>
          <div class="h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
          <div class="mt-4 h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
        </div>
        <div>
          <div class="h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
          <div class="mt-4 h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div>
          <div class="h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
          <div class="mt-4 h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
        </div>
        <div>
          <div class="h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
          <div class="mt-4 h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div>
          <div class="h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
          <div class="mt-4 h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
        </div>
        <div>
          <div class="h-4 w-32 animate-pulse rounded-xl bg-neutral-99" />
          <div class="mt-4 h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
        </div>
      </div>
    </div>

    <div>
      <div class="h-[38rem] rounded-lg border border-neutral-90 pb-2 pl-12 pr-12 pt-2">
        <div>
          <div class="flex flex-col items-center justify-center p-4">
            <svg class="h-6 text-neutral-99" viewBox="0 0 71 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.21071 8.68871C6.81843 8.68871 7.31108 8.13448 7.31108 7.4508C7.31108 6.76712 6.81843 6.21289 6.21071 6.21289C5.603 6.21289 5.11035 6.76712 5.11035 7.4508C5.11035 8.13448 5.603 8.68871 6.21071 8.68871Z"
                fill="rgb(245 245 245)"
              />
              <rect x="0.5" y="4.5" width="15" height="11" rx="1.5" stroke="rgb(245 245 245)" />
              <path
                d="M10.3081 10.2481C9.7251 9.46905 8.55709 9.46905 7.97407 10.2481L7.35116 11.0804C7.07934 11.4436 6.53478 11.4436 6.26296 11.0804C5.99114 10.7172 5.44657 10.7172 5.17476 11.0804L3.51866 13.2932C3.24743 13.6556 3.50604 14.1722 3.9587 14.1722H5.03724H8.57687H11.6685C12.3185 14.1722 12.6898 13.4304 12.3004 12.9101L10.3081 10.2481Z"
                fill="rgb(245 245 245)"
              />
              <path
                d="M27.453 5.06H29.273V14.44L28.279 13.418H33.991V15H27.453V5.06ZM39.4603 15.224C38.4803 15.224 37.6356 15.0187 36.9263 14.608C36.217 14.188 35.671 13.5907 35.2883 12.816C34.9056 12.032 34.7143 11.108 34.7143 10.044C34.7143 8.97067 34.901 8.04667 35.2743 7.272C35.657 6.488 36.203 5.886 36.9123 5.466C37.631 5.046 38.4803 4.836 39.4603 4.836C40.4403 4.836 41.285 5.046 41.9943 5.466C42.7036 5.886 43.245 6.488 43.6183 7.272C44.001 8.04667 44.1923 8.97067 44.1923 10.044C44.1923 11.108 44.001 12.032 43.6183 12.816C43.245 13.5907 42.7036 14.188 41.9943 14.608C41.285 15.0187 40.4403 15.224 39.4603 15.224ZM39.4603 13.642C40.0483 13.642 40.557 13.4973 40.9863 13.208C41.425 12.9187 41.7563 12.508 41.9803 11.976C42.2043 11.4347 42.3163 10.7907 42.3163 10.044C42.3163 9.29733 42.2043 8.65333 41.9803 8.112C41.7563 7.56133 41.4296 7.14133 41.0003 6.852C40.571 6.56267 40.0576 6.418 39.4603 6.418C38.8723 6.418 38.3636 6.56267 37.9343 6.852C37.505 7.14133 37.1783 7.56133 36.9543 8.112C36.7303 8.65333 36.6183 9.29733 36.6183 10.044C36.6183 10.7907 36.7303 11.4347 36.9543 11.976C37.1783 12.508 37.5003 12.9187 37.9203 13.208C38.3496 13.4973 38.863 13.642 39.4603 13.642ZM53.1337 15L52.9797 12.9L53.1617 13.068C53.0684 13.488 52.8677 13.8613 52.5597 14.188C52.261 14.5147 51.8877 14.7713 51.4397 14.958C51.001 15.1353 50.5297 15.224 50.0257 15.224C49.1017 15.224 48.2897 15 47.5897 14.552C46.8897 14.0947 46.3484 13.474 45.9657 12.69C45.5924 11.906 45.4057 11.024 45.4057 10.044C45.4057 9.064 45.597 8.17733 45.9797 7.384C46.3624 6.59067 46.9084 5.97 47.6177 5.522C48.327 5.06467 49.1577 4.836 50.1097 4.836C51.2017 4.836 52.107 5.13933 52.8257 5.746C53.5537 6.35267 54.0297 7.188 54.2537 8.252L52.3637 8.35C52.2237 7.734 51.9577 7.258 51.5657 6.922C51.183 6.586 50.6884 6.418 50.0817 6.418C49.4564 6.418 48.9337 6.57667 48.5137 6.894C48.103 7.21133 47.795 7.64533 47.5897 8.196C47.3937 8.73733 47.2957 9.35333 47.2957 10.044C47.2957 10.7347 47.3937 11.3507 47.5897 11.892C47.795 12.424 48.1077 12.8487 48.5277 13.166C48.9477 13.4833 49.4657 13.642 50.0817 13.642C50.539 13.642 50.9404 13.544 51.2857 13.348C51.631 13.1427 51.9017 12.8673 52.0977 12.522C52.2937 12.1767 52.4197 11.7753 52.4757 11.318H50.0677V9.876H54.2957V15H53.1337ZM60.3236 15.224C59.3436 15.224 58.4989 15.0187 57.7896 14.608C57.0803 14.188 56.5343 13.5907 56.1516 12.816C55.7689 12.032 55.5776 11.108 55.5776 10.044C55.5776 8.97067 55.7643 8.04667 56.1376 7.272C56.5203 6.488 57.0663 5.886 57.7756 5.466C58.4943 5.046 59.3436 4.836 60.3236 4.836C61.3036 4.836 62.1483 5.046 62.8576 5.466C63.5669 5.886 64.1083 6.488 64.4816 7.272C64.8643 8.04667 65.0556 8.97067 65.0556 10.044C65.0556 11.108 64.8643 12.032 64.4816 12.816C64.1083 13.5907 63.5669 14.188 62.8576 14.608C62.1483 15.0187 61.3036 15.224 60.3236 15.224ZM60.3236 13.642C60.9116 13.642 61.4203 13.4973 61.8496 13.208C62.2883 12.9187 62.6196 12.508 62.8436 11.976C63.0676 11.4347 63.1796 10.7907 63.1796 10.044C63.1796 9.29733 63.0676 8.65333 62.8436 8.112C62.6196 7.56133 62.2929 7.14133 61.8636 6.852C61.4343 6.56267 60.9209 6.418 60.3236 6.418C59.7356 6.418 59.2269 6.56267 58.7976 6.852C58.3683 7.14133 58.0416 7.56133 57.8176 8.112C57.5936 8.65333 57.4816 9.29733 57.4816 10.044C57.4816 10.7907 57.5936 11.4347 57.8176 11.976C58.0416 12.508 58.3636 12.9187 58.7836 13.208C59.2129 13.4973 59.7263 13.642 60.3236 13.642Z"
                fill="rgb(245 245 245)"
              />
            </svg>
          </div>
        </div>

        <div class="grid gap-4 bg-white p-6 text-center">
          <div class="m-auto h-4 w-24 animate-pulse rounded-xl bg-neutral-99" />
          <div class="m-auto">
            <!-- Icon -->
            <svg class="h-16 w-16 text-neutral-99" viewBox="0 0 65 66" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M42.6564 28.5804V16.3929C42.6564 10.7837 38.1093 6.2366 32.5002 6.2366C26.891 6.2366 22.3439 10.7837 22.3439 16.3929V28.5804M53.0998 23.1833L56.5209 55.6833C56.7102 57.4823 55.2997 59.0491 53.4907 59.0491H11.5096C9.70067 59.0491 8.2901 57.4823 8.47947 55.6833L11.9005 23.1833C12.0638 21.6326 13.3714 20.4554 14.9307 20.4554H50.0697C51.629 20.4554 52.9366 21.6326 53.0998 23.1833ZM23.3595 28.5804C23.3595 29.1413 22.9048 29.596 22.3439 29.596C21.783 29.596 21.3283 29.1413 21.3283 28.5804C21.3283 28.0194 21.783 27.5647 22.3439 27.5647C22.9048 27.5647 23.3595 28.0194 23.3595 28.5804ZM43.6721 28.5804C43.6721 29.1413 43.2173 29.596 42.6564 29.596C42.0955 29.596 41.6408 29.1413 41.6408 28.5804C41.6408 28.0194 42.0955 27.5647 42.6564 27.5647C43.2173 27.5647 43.6721 28.0194 43.6721 28.5804Z"
                stroke="rgb(245 245 245)"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="m-auto h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
          <div class="m-auto h-8 w-24 animate-pulse rounded-full bg-neutral-99" />

          <hr class="m-0 border-neutral-95" />

          <div class="grid gap-4 bg-white p-4 text-center">
            <div class="m-auto h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />
            <div class="m-auto h-8 w-24 animate-pulse rounded-full bg-neutral-99" />
          </div>

          <hr class="m-0 border-neutral-95" />

          <div class="grid gap-4 bg-white p-6 text-center">
            <div class="m-auto h-4 w-12 animate-pulse rounded-xl bg-neutral-99" />

            <div class="m-auto flex flex-row gap-4">
              <div class="h-4 w-4 animate-pulse rounded-xl bg-neutral-99" />
              <div class="h-4 w-4 animate-pulse rounded-xl bg-neutral-99" />
              <div class="h-4 w-4 animate-pulse rounded-xl bg-neutral-99" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
